// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1oDIr","col":"CardReaderDesc_col__tc2A5","label":"CardReaderDesc_label__2Rhap"};